<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>
<script>
  import store from './store/'
  export default {
    name: 'app'
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .main {
    background-color: #f5f5f5;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// App.vue?25308716